import moment from 'moment'
export function formatDDMMYYYY(val) {
  if (val) {
    return moment(val).format('DD/MM/YYYY')
  } else {
    return val
  }
}
export function formatHHmmDDMMYYYY(val) {
  if (val) {
    return moment(val).format('HH:mm DD/MM/YYYY')
  } else {
    return val
  }
}
export function formatTimeISO(val) {
  if (val) {
    return moment(val).format('YYYY-MM-DD HH:mm:ss')
  } else {
    return ''
  }
}
